import { DictionaryValue } from '@sdbn/common-essential';


/** Transport Management Service Model **/

export class TransportCabotageCheck {
  id: string | undefined;
  insertDate: string | undefined;
  updateDate: string | undefined;
  transportId: string | undefined;
  numberPlate: string | undefined;
  constructor(value?: Partial<TransportCabotageCheck>) {
    if (value != null) {
      this.id = value.id;
      this.insertDate = value.insertDate;
      this.updateDate = value.updateDate;
      this.transportId = value.transportId;
      this.numberPlate = value.numberPlate;
    }
  }
}



/** Transport Management DB Model **/

export class VehicleArchive {
  id: string | undefined;
  insertDate: string | undefined;
  updateDate: string | undefined;
  blocked: boolean | undefined;
  numberPlateNormalized: string | undefined;
  cabotageWhitelisted: boolean | undefined;
  note: string | undefined;
  whitelisted: boolean | undefined;
  numberplate: string | undefined;
  constructor(value?: Partial<VehicleArchive>) {
    if (value != null) {
      this.id = value.id;
      this.insertDate = value.insertDate;
      this.updateDate = value.updateDate;
      this.blocked = value.blocked;
      this.numberPlateNormalized = value.numberPlateNormalized;
      this.cabotageWhitelisted = value.cabotageWhitelisted;
      this.note = value.note;
      this.whitelisted = value.whitelisted;
      this.numberplate = value.numberplate;
    }
  }
}

